<template>
  <div>
    <HeroSection
      :nav-breadcrumbs="[
        {
          href: '/resources',
          title: 'Resources'
        }
      ]"
      :value="resourcesPage.hero_section"
    >
      <template v-if="resourcesPage.hero_section.cta" #cta>
        <HeroCta :value="resourcesPage.hero_section.cta" />
      </template>
    </HeroSection>

    <ResourcesSection
      :filters-value="filtersValue"
      :value="resourcesPage.resources_section"
      class="mb-16 hero-section hero-below-offset"
      @update:filters-value="updateLocation"
    />

    <DividerSection class="mb-16" />

    <ContactCtaSection
      :value="resourcesPage.contact_cta_section"
      class="mb-16"
    />
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { FILTER_TYPE_ALL } from '#root/lib/consts'

defineProps({
  resourcesPage: {
    required: true,
    type: Object
  }
})

const filtersValue = ref()

function getIDParams(url, singular, plural) {
  let all = url.searchParams.getAll(singular)
  const list = url.searchParams.get(plural)
  if (list) all.push(...list.split(','))
  all = all.map(id => parseInt(id) || 0).filter(id => id > 0)
  return [...new Set(all)].sort()
}

function updateLocation({ courses, topics, type }) {
  const url = new URL(window.location.href)
  const params = url.searchParams
  params.delete('course')
  params.delete('courses')
  params.delete('topic')
  params.delete('topics')
  params.delete('type')

  if (courses && courses.length)
    courses.forEach(id => params.append('course', id))
  if (topics && topics.length) topics.forEach(id => params.append('topic', id))
  if (type && type !== FILTER_TYPE_ALL) params.append('type', type)

  window.history.replaceState({}, '', url.href)
}

onMounted(async () => {
  const url = new URL(window.location.href)
  const courses = getIDParams(url, 'course', 'courses')
  const topics = getIDParams(url, 'topic', 'topics')
  const types = getIDParams(url, 'type', 'types')

  filtersValue.value = {
    ...(courses.length ? { courses } : undefined),
    ...(topics.length ? { topics } : undefined),
    ...(types.length ? { type: types[0] } : undefined)
  }
})
</script>
